<template>
  <app-card
    :height="height"
    :min-width="collapsedInner ? 52 : 250"
    :max-width="collapsedInner ? 52 : 250"
    style="transition: .8s;"
    class="pa-0 d-flex flex-column overflow-hidden"
  >
    <v-hover
      v-if="collapsedInner"
      v-slot="{ hover }"
      key="3"
    >
      <div
        key="1"
        class="grow py-3 d-flex flex-column justify-start align-center"
        @click="toggleCollapse()"
      >
        <div class="flex-equal">
          <v-icon style="margin-top: 2px;" :color="hover ? 'primary' : undefined">{{ categoriesIcon }}</v-icon>
        </div>
        <div class="flex-equal d-flex flex-column justify-center">
          <v-icon :color="hover ? 'primary' : undefined">mdi-chevron-right</v-icon>
        </div>

        <div class="flex-equal">
        </div>
      </div>
    </v-hover>

    <div
      v-else
      key="2"
      class="flex-grow-0 fill-height pa-0 pt-0 pr-0 d-flex flex-column fill-width"
    >
      <div class="fill-width d-flex flex-row justify-center pa-1 pt-2">
        <v-hover v-slot="{ hover }">
          <app-card
            class="title rounded pa-2 ma-n3 mt-n1 ml-n3 d-flex flex-row align-center fill-width"
            :class="{ 'primary--text': hover }"
            @click="toggleCollapse()"
          >
            <v-icon class="mr-4" style="margin-left: 2px;" :color="hover ? 'primary' : undefined">{{ categoriesIcon }}</v-icon>

            <div class="pt-1 text-uppercase font-weight-bold">Catalog</div>

            <v-spacer/>

            <v-icon :color="hover ? 'primary' : undefined">mdi-chevron-left</v-icon>
          </app-card>
        </v-hover>
      </div>


      <div class="overflow-y-scroll mt-4 flex-grow-1 pr-0 pl-4 mr-1">
        <v-treeview
          :active.sync="active"
          :items="itemsAndAll"
          :open="[ ALL_TITLE ]"
          item-text="title"
          item-key="title"
          class="mr-1"
          activatable
          hoverable
          active-class="rounded primary--text active"
          selected-color="primary"
          dense
          loading
          @update:active="onUpdateActive"
        >
          <template #label="{ item, leaf }">
            <div
              :class="{
                'title': !leaf,
              }"
              v-intersect="{
                handler: onIntersect(item),
                options: {
                  threshold: [ 1.0 ]
                }
              }"
              class="cursor-pointer"
            >
              {{ item.title }}
            </div>
          </template>

          <template #append="{ item }">
            <div v-if="!isNaN(+item.materials)">
              {{ item.materials }}
            </div>
          </template>
        </v-treeview>
      </div>

      <div class="pa-4 pt-2">
        <div class="relative">
          <v-progress-linear
            v-show="loading"
            indeterminate
            absolute
            rounded
            top
            color="grey"
          />
        </div>
      </div>
    </div>
  </app-card>
</template>

<script>
  import config from '@/config';
  const ALL_TITLE = config.common.ALL_MATERIALS_TITLE;

  export default {
    name: "MaterialCategories",
    props: {
      items: {
        type: Array,
        required: true,
      },
      value: {
        type: Array,
        default: () => [],
      },
      collapsedStart: {
        type: Boolean,
        default: false,
      },
      loading: {
        type: Boolean,
        default: false,
      },
      total: {
        type: Number,
      },
      height: {
        type: Number,
      },
      mandatory: {
        type: Boolean,
        default: false,
      },
      collapsable: {
        type: Boolean,
        default: true
      }
    },

    data() {
      return {
        collapsedInner: this.collapsedStart,
        categoriesIcon: '$vuetify.icons.list',
        active: this.value,
        ALL_TITLE,
      }
    },

    computed: {
      itemsAndAll() {
        const { items, total } = this;
        return [
          {
            id: -1,
            title: ALL_TITLE,
            class: 'title',
            materials: total,
            children: items ? [ ...items ] : [],
          },
        ]
      }
    },

    watch: {
      value: {
        immediate: true,
        deep: true,
        handler(v) {
          this.active = this.getValueOrDefault(v);
        }
      }
    },

    methods: {
      onUpdateActive(v) {
        this.$emit('input',  this.getValueOrDefault(v));
      },

      getValueOrDefault(v) {
        // let found = this.items.find( item => item.id === v );
        if (!this.mandatory) return v;
        return v.length === 0 ? [ ALL_TITLE ] : v
      },

      toggleCollapse() {
        if (this.collapsable) {
          this.collapsedInner = !this.collapsedInner;
          this.$emit('toggle:collapse', this.collapsedInner);
        } else this.$emit('toggle:collapse', false);
      },

      onIntersect(item) {
        return (entries) => {
          if (entries[0].intersectionRatio <= 0.5) return;

          const { items, loading } = this;

          if (loading) return;

          let lastItem = items[items.length - 1];
          let isElementInLastRow = !lastItem || item.id === lastItem.id;
          if (!isElementInLastRow) return;

          this.$emit("scroll:last");
        }
      },
    },
  }
</script>
